// Single source of truth for music platform buttons (section + every track card).
// Only official direct pages are used: search URLs are never shown, not even as a fallback.
const RULES = {
  spotify: { host: /^open\.spotify\.com$/, path: /^\/(intl-[a-z-]+\/)?(track|album|artist)\/[A-Za-z0-9]+\/?$/ },
  youtube_music: { host: /^music\.youtube\.com$/, path: /^\/(watch|playlist|channel\/[\w-]+|browse\/[\w-]+)\/?$/ },
  amazon: { host: /^music\.amazon\.(com|it|es|de|fr|co\.uk|ca|com\.br|com\.mx|co\.jp|in|com\.au)$/, path: /^\/(albums|tracks|artists)\/[A-Za-z0-9]+/ },
  deezer: { host: /^(www\.)?deezer\.com$|^link\.deezer\.com$|^deezer\.page\.link$/, path: /^\/([a-z]{2}\/)?(track|album|artist)\/\d+\/?$|^\/s\/[\w-]+$|^\/[\w-]+$/ },
  apple: { host: /^music\.apple\.com$/, path: /^\/[a-z]{2}\/(album|song|artist)\// },
};

export const officialLink = (platform, v) => {
  if (typeof v !== "string" || !v.trim() || !RULES[platform]) return null;
  try {
    const u = new URL(v.trim());
    const r = RULES[platform];
    if (u.protocol !== "https:" || /search/i.test(u.pathname + u.search) || !r.host.test(u.hostname) || !r.path.test(u.pathname)) return null;
    if (platform === "youtube_music" && u.pathname.startsWith("/watch") && !u.searchParams.get("v")) return null;
    if (platform === "youtube_music" && u.pathname.startsWith("/playlist") && !u.searchParams.get("list")) return null;
    if (platform === "apple") u.searchParams.delete("uo");
    return u.toString();
  } catch {
    return null;
  }
};

export const TRACK_PLATFORMS = [
  { k: "spotify", label: "Spotify", bg: "#1DB954" },
  { k: "apple", label: "Apple", bg: "#FA243C" },
  { k: "youtube_music", label: "YT Music", bg: "#FF0000" },
  { k: "amazon", label: "Amazon", bg: "#1f9fb0" },
  { k: "deezer", label: "Deezer", bg: "#A238FF" },
];

// Official artist page per platform (Admin > Link, Apple from the iTunes catalogue). null = missing.
export const artistLinks = (content, tracks) => {
  const out = {};
  for (const { k } of TRACK_PLATFORMS) out[k] = officialLink(k, content?.streaming?.[k]);
  const apple = (tracks || []).map((t) => officialLink("apple", t.artist_url)).find(Boolean);
  if (apple) out.apple = apple;
  return out;
};

// Buttons of one release: direct link if known, otherwise the official artist page marked as such.
export const trackLinks = (tr, artist) =>
  TRACK_PLATFORMS.map((p) => {
    const direct = p.k === "apple" ? officialLink("apple", tr.apple_url) : officialLink(p.k, tr.links?.[p.k]);
    if (direct) return { ...p, href: direct, artist: false };
    if (artist[p.k]) return { ...p, href: artist[p.k], artist: true };
    return null;
  }).filter(Boolean);
